export default "<style>\r\n  \r\n  small-info\r\n  {\r\n    font-size: 75%;\r\n    opacity: 0.7;\r\n  }\r\n\r\n</style>\r\n\r\n<small-info>@{}</small-info>";